import { useState } from 'react';
import './styles.scss';
import { isEmailValid } from './helpers';

const FormControlInput = ({ value, onChange, label, placeholder, required = false, type, className = '' }) => {
    const [invalid, setInvalid] = useState('');
    const handleChange = e => onChange(e.target.value);
    const handleBlur = () => {
        if (required) {
            setInvalid(value === '' ? 'This field is required' : '');
        }
        if (type === 'email') {
            setInvalid(isEmailValid(value) ? '' : 'Invalid value');
        }
    };
    return (
        <div className={`form-control-container ${className}`}>
            <label className={`form-control ${invalid ? 'invalid' : ''}`}>
                {label && (
                    <span className="form-control__label">
                        {label}
                        {required ? '*' : ''}
                    </span>
                )}
                <input
                    onBlur={handleBlur}
                    type="text"
                    placeholder={placeholder}
                    value={value}
                    onChange={handleChange}
                    className="form-control__input"
                />
                {invalid && <div className="invalid-text">{invalid}</div>}
            </label>
        </div>
    );
};

export default FormControlInput;
